import { render, staticRenderFns } from "./ViewUserPage.vue?vue&type=template&id=2b6f96c6"
import script from "./ViewUserPage.vue?vue&type=script&lang=js"
export * from "./ViewUserPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports